<template>
  <div class="leg-container">
    <div
      v-if="leg.mode!== 'WALK' || isFirst"
      class="itinerary-row"
    >
      <h2 class="left-slot">{{format(new Date(leg.startTime), 'HH:mm')}}</h2>
      <TransitNode
        :isFirst="isFirst"
        :prevMode="prevLeg ? 'WALK' : undefined"
        :mode="leg.mode"
        :nextMode="leg.mode"
      />
      <h2
        @click="flyTo(leg.from)"
        class="right-slot pointer"
      >{{ isFirst ? getPlaceVejnavn(fromPlace) : leg.from.name }}
        <span class="tool-tip">Zoom til i kort</span>
      </h2>
    </div>
    <div class="itinerary-row">
      <div class="left-slot"></div>
      <TransitLine :mode="leg.mode" />
      <div
        class="leg-box right-slot"
        v-bind:class="{
        bicycle: leg.mode === 'BICYCLE',
        rail: leg.mode === 'RAIL',
        bus: leg.mode === 'BUS',
        walk: leg.mode === 'WALK',
      }"
      >
        <div style="font-weight: 700; font-size: 15px; display:flex;">
          <ModeIcon
            :mode="leg.mode"
            :color="leg.mode === 'WALK' ? '#343a65' :'#FFF'"
            :width="leg.mode === 'WALK' ? 15 : 27"
          />
          <div style="margin-left:15px; display: flex; flex-direction: column; justify-content: center">
            {{ duration }}
          </div>
          <div
            v-if="leg.mode === 'BUS' || leg.mode === 'RAIL'"
            class="route-number"
          >
            {{leg.route}}
          </div>
          <span class="tool-tip">Tid baseret på en gennemsnitlig<br>cykelhastighed på 10 km/t</span>
        </div>
        <p>
          {{ capitalize(modeText(leg.mode)) }}
          {{ leg.mode === 'BUS' || leg.mode === 'RAIL' ? getRouteString(leg) :getDistanceString(leg.distance) }}
        </p>
        <button
          class="btn-se-detaljer"
          @click="onShowDetailClick"
          v-if="leg.mode === 'BUS' || leg.mode === 'RAIL'"
        >
          <div v-if="showDetails">
            <chevron-up :iconColor="leg.mode === 'WALK' ? '#343a65' :'#FFF'" />
            <span class="btn-text">{{leg.intermediateStops.length +1}} holdepladser</span>
          </div>
          <div v-else>
            <chevron-down :iconColor="leg.mode === 'WALK' ? '#343a65' :'#FFF'" />
            <span class="btn-text">{{leg.intermediateStops.length +1}} holdepladser</span>
          </div>
        </button>
        <button
          class="btn-se-detaljer"
          @click="onShowDetailClick"
          v-else
        >
          <div v-if="showDetails">
            <chevron-up :iconColor="leg.mode === 'WALK' ? '#343a65' :'#FFF'" />
            <span class="btn-text">Skjul detaljer</span>
          </div>
          <div v-else>
            <chevron-down :iconColor="leg.mode === 'WALK' ? '#343a65' :'#FFF'" />
            <span class="btn-text">Vis detaljer</span>
          </div>
        </button>
      </div>
    </div>
    <div
      v-if="showDetails"
      class="itinerary-row"
    >
      <div class="left-slot"></div>
      <TransitLine :mode="leg.mode" />
      <div class="right-slot">
        <leg-details :leg="leg" />
      </div>

    </div>
    <div
      v-if="leg.mode!== 'WALK' || isLast"
      class="itinerary-row"
    >
      <h2 class="left-slot">{{format(new Date(leg.to.arrival), 'HH:mm')}}</h2>
      <TransitNode
        :prevMode="leg.mode"
        :mode="leg.mode"
        :nextMode=" nextLeg ? 'WALK' : undefined"
        :isLast="isLast"
      />
      <h2
        @click="flyTo(leg.to)"
        class="right-slot pointer"
      >{{ isLast ? getPlaceVejnavn(toPlace) : leg.to.name }}
        <span class="tool-tip">Zoom til i kort</span>
      </h2>
    </div>
    <WaitLeg
      v-if="showWaitLeg(leg, nextLeg)"
      :nextLeg="nextLeg"
      :leg="leg"
    />
  </div>
</template>

<script>
import { format } from 'date-fns';
import ModeIcon from '@/components/Icons/ModeIcon.vue';
import LegDetails from '@/components/Itinerary/LegDetails.vue';
import TransitLine from '@/components/Itinerary/TransitNodes/TransitLine.vue';
import TransitNode from '@/components/Itinerary/TransitNodes/TransitNode.vue';
import WaitLeg from '@/components/Itinerary/WaitLeg';
import ChevronDown from '@/components/Icons/ChevronDown.vue';
import ChevronUp from '@/components/Icons/ChevronUp.vue';
import {
  capitalizeFirstLetter,
  modeToDanish,
  getPlaceVejnavn,
  getDistanceString,
} from '@/util';
import { getDurationString } from '@/util/itinerary';
export default {
  name: 'leg',
  components: {
    ModeIcon,
    ChevronDown,
    ChevronUp,
    LegDetails,
    TransitLine,
    TransitNode,
    WaitLeg,
  },
  props: {
    leg: Object,
    nextLeg: Object,
    prevLeg: Object,
    isFirst: Boolean,
    fromPlace: Object,
    isLast: Boolean,
    toPlace: Object,
  },
  data: function() {
    return {
      getDistanceString,
      getDurationString,
      showDetails: !!this.leg.steps.find(
        step => step.farligeKryds !== undefined
      ),
      format,
      getPlaceVejnavn,
    };
  },
  methods: {
    showWaitLeg(leg, nextLeg) {
      if (leg.mode === 'WALK' && nextLeg) {
        const waitDuration = (nextLeg.startTime - leg.endTime) / 1000;
        if (getDurationString(waitDuration)) {
          return true;
        }
      }
      return nextLeg && nextLeg.mode !== 'WALK' && leg.mode !== 'WALK';
    },
    flyTo(latLng) {
      this.$store.commit('stepClicked', latLng);
    },
    onShowDetailClick() {
      this.showDetails = !this.showDetails;
    },
    modeText(mode) {
      return modeToDanish(mode);
    },
    capitalize(string) {
      return capitalizeFirstLetter(string);
    },
    getRouteString(leg) {
      return ` ${leg.route} mod ${leg.headsign}`;
    },
  },
  computed: {
    duration() {
      let { duration } = this.leg;
      const durationString = this.getDurationString(duration);
      return durationString || 'Under 1 min';
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin: 25px 0;
  line-height: 150%;
  position: relative;
}

h2.right-slot {
  margin: 20px 18px;
}

.bicycle > div {
  position: relative;
}

.bicycle > div > div:nth-child(2) {
  cursor: help;
}

.bicycle > div .tool-tip {
  left: 0;
  margin-left: -70px;
}

h2:hover .tool-tip,
.bicycle > div:hover .tool-tip {
  bottom: -3em;
  display: block;
}

.bicycle > div:hover .tool-tip {
  bottom: -4.5em;
}

.leg-container {
  font-size: 14px;
  /* margin-top: 10px; */
}
.leg-box {
  border-radius: 6px;
  color: #fff;
  padding: 16px;
}
.bicycle {
  background-color: $pink-500;
}

.rail {
  background-color: $green-500;
}

.bus {
  background-color: $yellow-500;
}
.walk {
  background-color: rgba(215, 216, 230, 0.078);
  color: $primary-700;
  border: 1px solid #efeff4;
}

.wait {
  color: $primary-500;
  opacity: 0.7;
  padding: 16px 0 0 !important;
}

.wait > div {
  font-weight: 600 !important;
}

.btn-se-detaljer {
  background-color: transparent;
  border: none;
  color: white;
  padding: 0;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: inherit;
  margin: 4px 2px;
  cursor: pointer;
  font-weight: 600;
  text-decoration: underline;
}

.walk > .btn-se-detaljer {
  color: #0f1c70;
}

.btn-text {
  margin-left: 11px;
}

.pointer {
  cursor: pointer;
}

.route-number {
  margin-left: auto;
  padding: 2px 6px;
  background-color: #ffffff;
  border-radius: 3px;
  font-size: 14px;
}

.bus .route-number {
  color: $yellow-500;
}

.bus .mode-icon {
  margin-top: 3px;
}

.rail .route-number {
  color: $green-500;
}

@media only screen and (max-width: $mobile-max-width) {
  h2 {
    font-size: 15px;
  }
}
</style>
